import { React, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sidenav, Nav } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { useTranslation } from 'react-i18next';
import {
  FaFile,
  FaFileInvoice,
  FaDownload,
  FaBarcode,
  FaBullhorn,
  FaReceipt,
  FaBookOpen,
} from 'react-icons/fa';

import DocPassIcon from '@rsuite/icons/DocPass';
import DetailIcon from '@rsuite/icons/Detail';

export default function SideNav() {
  const [expanded, setExpanded] = useState(true);
  const { t, i18n } = useTranslation();
  return (
    <>
      {/* <center> */}
      <Sidenav expanded={expanded} defaultOpenKeys={['1']} className='sideNav'>
        <div className='row mx-0'>
          <div
            className={`${i18n.language === 'en' ? 'text-end' : 'text-start'} ${
              expanded ? '' : 'text-center'
            } btn`}
            onClick={() => setExpanded(!expanded)}>
            {i18n.language === 'en' ? <span>&lt;&lt;</span> : <span>&gt;&gt;</span>}
          </div>
        </div>
        <Sidenav.Body>
          <Link to={'/home/welcome'}>
            <div className='row p-auto text-center mx-0'>
              <img
                src='/Sobol_logo.png'
                alt='Sobol Logo'
                className={`${expanded ? 'layout__logo--original' : 'layout__logo--scaled'} mx-0`}
              />
            </div>
          </Link>
          <Nav activeKey='1'>
            <Nav.Menu
              placement={`${i18n.language === 'ar' ? 'leftStart' : 'rightStart'}`}
              eventKey='1'
              title={
                <>
                  <span
                    className={`d-flex justify-content-start px-2 ${
                      i18n.language === 'ar' ? 'arabic' : ''
                    }`}>
                    {t('layout.sidenav.invoice')}
                  </span>
                </>
              }
              className='fw-bold'
              icon={expanded ? i18n.language === 'ar' ? <></> : <DocPassIcon /> : <DocPassIcon />}>
              <Nav.Item
                eventKey='1-1'
                icon={<FaFile />}
                as={Link}
                to={'document/new'}
                className={`${i18n.language === 'ar' ? 'd-flex flex-row-reverse px-5' : ''}`}>
                <span
                  style={{ color: '#585858' }}
                  className={`${i18n.language === 'en' ? 'ms-1' : 'me-1'} text-nowrap`}>
                  {t('layout.sidenav.newDocument')}
                </span>
              </Nav.Item>
              <Nav.Item
                eventKey='1-2'
                icon={<FaFileInvoice />}
                as={Link}
                to={'documents/all'}
                className={`${i18n.language === 'ar' ? 'd-flex flex-row-reverse px-5' : ''}`}>
                <span
                  style={{ color: '#585858' }}
                  className={`${i18n.language === 'en' ? 'ms-1' : 'me-1'}`}>
                  {t('layout.sidenav.documents')}
                </span>
              </Nav.Item>
              <Nav.Item
                eventKey='1-3'
                icon={<FaDownload />}
                as={Link}
                to={'documents/packages'}
                className={`${i18n.language === 'ar' ? 'd-flex flex-row-reverse px-5' : ''}`}>
                <span
                  style={{ color: '#585858' }}
                  className={`${i18n.language === 'en' ? 'ms-1' : 'me-1'} text-nowrap`}>
                  {t('layout.sidenav.packages')}
                </span>
              </Nav.Item>
            </Nav.Menu>
            {/* <Nav.Menu
                placement='rightStart'
                eventKey='2'
                title='Receipts'
                className='fw-bold'
                icon={<DetailIcon />}>
                <Nav.Item eventKey='2-1' icon={<FaReceipt />} as={Link} to={''}>
                  <span style={{ color: '#585858' }} className='ms-2'>
                    Receipts
                  </span>
                </Nav.Item>
                <Nav.Item eventKey='2-2' icon={<FaDownload />} as={Link} to={''}>
                  <span style={{ color: '#585858' }} className='ms-2'>
                    Packages
                  </span>
                </Nav.Item>
              </Nav.Menu> */}
            <Nav.Item
              eventKey='3'
              className={`${i18n.language === 'ar' ? 'd-flex flex-row-reverse px-3' : 'ps-3'} ${
                !expanded ? 'justify-content-center' : ''
              } fw-bold bg-white`}
              icon={<FaBarcode />}
              as={Link}
              to={'codes'}>
              <span className={expanded ? (i18n.language === 'ar' ? 'mx-3' : 'ps-4') : 'd-none'}>
                {t('layout.sidenav.codes')}
              </span>
            </Nav.Item>
            {/* <Nav.Item
                eventKey='4'
                className='fw-bold bg-white ps-3'
                icon={<FaBullhorn />}
                as={Link}
                to={''}>
                <span className={expanded ? 'ps-4' : 'd-none'}>Notifications</span>
              </Nav.Item>
              <Nav.Item
                eventKey='5'
                className='fw-bold bg-white ps-3'
                icon={<FaBookOpen />}
                as={Link}
                to={''}>
                <span className={expanded ? 'ps-4' : 'd-none'}>User Guide</span>
              </Nav.Item> */}
            <Nav.Item
              eventKey='5'
              className={`${i18n.language === 'ar' ? 'd-flex flex-row-reverse' : ''} ${
                !expanded ? 'justify-content-center' : ''
              } fw-bold bg-white px-3`}
              icon={<FaDownload />}
              as={Link}
              to={'reports'}>
              <span className={expanded ? (i18n.language === 'ar' ? 'mx-3' : 'ps-4') : 'd-none'}>
                {t('layout.sidenav.reports')}
              </span>
            </Nav.Item>
          </Nav>
        </Sidenav.Body>
      </Sidenav>
      {/* </center> */}
    </>
  );
}
